import {
  Error,
  UpdateOneSubuserAccount,
  InsertOneSubuserAccount,
  DeleteSubuserAccount,
  GetOneSubuserAccount,
  getFilesubuser,
  GetAllSubuserAccount
} from "../type";
const initialState = {
  SubuserAccounts: [],
  CreateSubuserAccounts: [],
  DeleteAccounts: [],
  UpdateAccounts: [],
  OneAccount: [],
  Filesubuser: [],
  loading: true,
};
const SubuserR = (state = initialState, action) => {
  switch (action.type) {
    case GetAllSubuserAccount:
      return {
        ...state,
        SubuserAccounts: action.payload,
        loading: false,
      };
      case getFilesubuser:
        return {
          SubuserAccounts:state.SubuserAccounts,
          Filesubuser: action.payload,
          loading: false,
        };
    case GetOneSubuserAccount:
      return {
        OneAccount: action.payload,
        loading: false,
      };
    case InsertOneSubuserAccount:
      return {
        SubuserAccounts:state.SubuserAccounts,
        CreateSubuserAccounts: action.payload,
        loading: false,
      };
    case UpdateOneSubuserAccount:
      return {
        SubuserAccounts:state.SubuserAccounts,
        UpdateAccounts: action.payload,
        loading: false,
      };
    case DeleteSubuserAccount:
      return {
        SubuserAccounts:state.SubuserAccounts,
        DeleteAccounts: action.payload,
        loading: false,

      };
    case Error:
      return {
        loading: false,
        SubuserAccounts: action.payload,
      };
    default:
      return state;
  }
};
export default SubuserR;
